export enum StepType {
  CREATED = 'CREATED',

  BLOCKED = 'BLOCKED',

  ACCEPTED = 'ACCEPTED',

  SENT = 'SENT',

  GAINED = 'GAINED',

  LOST = 'LOST',

  COMPLETED = 'COMPLETED',

  REJECTED = 'REJECTED',

  CANCEL = 'CANCEL',
}
